import { useEffect, useState } from 'react';
// @mui
import { Box, Button, IconButton, TextField, InputAdornment, Stack, Tooltip } from '@mui/material';
// components
import Iconify from '../../components/Iconify';

const FILE_MAX_LENGTH = 3;


export default function AddPastTimeFiles({ files, setFiles }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleAdd = () => {
    setFiles((prev) => [...prev, { name: '', file: '' }]);
  };

  const handleRemove = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpdate = (index) => {
    return (e) => {
      const newItem = { name: e.target.files[0].name, file: e.target.files[0] };
      setFiles((prev) => prev.map((item, i) => i === index ? newItem : item));
    }
  }
  
  return (
    <Box sx={{ py: 1 }}>
      <Stack spacing={2} sx={{ mb: files?.length > 0 ? 2 : 0  }}>
        {files.map((item, index) => (
          <Stack key={`files[${index}]`} direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center" justifyContent="space-between">
            <FileUploadField item={item} index={index} updateItem={handleUpdate(index)} />
            <Button
              color="error"
              onClick={() => handleRemove(index)}
            >
              삭제
            </Button>
          </Stack>
        ))}
      </Stack>
      
      {files.length < FILE_MAX_LENGTH &&
      <>
        <Button disabled={!(files.length < FILE_MAX_LENGTH)} size="small" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleAdd} sx={{ flexShrink: 0 }}>
          파일 추가하기
        </Button>
        <Tooltip
          title="파일 선택창이 열리지 않을 경우, 브라우저 업데이트 후 다시 시도해주세요."
          placement="bottom"
          arrow
          disableFocusListener
          disableHoverListener
          open={tooltipOpen}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => setTooltipOpen(false)}
          componentsProps={{
            tooltip: {
              sx: { p: 1, width: 200, maxWidth: "none" },
            },
          }}
        >
          <IconButton size="small" onClick={() => setTooltipOpen((prev) => !prev)}>
            <Iconify icon="eva:info-fill" />
          </IconButton>
        </Tooltip>
      </>
      }
    </Box>
  );
}


function FileUploadField({ index, item, updateItem }) {
  const [fileName, setFileName] = useState('');

  const handleChangeFile = (e) => {
    if (e.target.files.length) {
      // form 으로 전달할 값은 여기서 세팅 (uploaded file id)
      updateItem(e);

      // textfield 에 보여줄 값은 여기서 세팅 (file name)
      setFileName(e.target.files[0].name);
    }
  }

  useEffect(() => {
    if (item && item.file) {
      setFileName(item.file.name);
    }
  }, [item]);

  return (
    <Stack spacing={1} sx={{ width: 1 }}>
      <TextField
        fullWidth
        value={fileName}
        placeholder={"파일을 업로드 해주세요"}
        InputProps={{
          readOnly: true,
          endAdornment: <InputAdornment position="end">
            <Button
              variant={"contained"}
              component="label"
              edge="end"
              disableFocusRipple
            >
              파일 선택
              <input id={`files[${index}]`} style={{ display: 'none' }} type='file' name={`files[${index}]`} onChange={handleChangeFile} />
            </Button>
          </InputAdornment>
        }}
      />
    </Stack>
  )
}